export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.512 8.56c.243.284.21.71-.073.952l-7 6a.675.675 0 01-.878-1.024l7-6a.675.675 0 01.951.073z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.063 4.334l-14.57 8.571 11.999 5.143 2.571-13.714zm-.455-1.298c.91-.535 2.025.249 1.831 1.285l-2.648 14.124a1.229 1.229 0 01-1.692.903L3.74 14.052a1.229 1.229 0 01-.139-2.189l15.007-8.827z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 14.325c.373 0 .675.302.675.675v4.739l1.95-1.3a.675.675 0 11.75 1.123l-2.14 1.426a1.229 1.229 0 01-1.91-1.023V15c0-.373.302-.675.675-.675z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};